var w = Object.defineProperty;
var r = Object.getOwnPropertySymbols;
var i = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var c = (e, t, l) => t in e ? w(e, t, { enumerable: !0, configurable: !0, writable: !0, value: l }) : e[t] = l, m = (e, t) => {
  for (var l in t || (t = {}))
    i.call(t, l) && c(e, l, t[l]);
  if (r)
    for (var l of r(t))
      n.call(t, l) && c(e, l, t[l]);
  return e;
};
var s = (e, t) => {
  var l = {};
  for (var a in e)
    i.call(e, a) && t.indexOf(a) < 0 && (l[a] = e[a]);
  if (e != null && r)
    for (var a of r(e))
      t.indexOf(a) < 0 && n.call(e, a) && (l[a] = e[a]);
  return l;
};
import * as C from "react";
const h = (a) => {
  var o = a, {
    title: e,
    titleId: t
  } = o, l = s(o, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ C.createElement("svg", m({ width: 32, height: 32, viewBox: "0 0 13 10", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t }, l), e ? /* @__PURE__ */ C.createElement("title", { id: t }, e) : null, /* @__PURE__ */ C.createElement("path", { d: "M10.9606 0.388969L4.67645 7.22225L2.03238 4.76671C1.7316 4.48485 1.29327 4.37478 0.882458 4.478C0.471549 4.58113 0.150679 4.88182 0.0406243 5.26688C-0.0695137 5.65186 0.0479422 6.06263 0.348712 6.34447L3.90576 9.67778C4.13298 9.88082 4.43367 9.99591 4.74759 10C5.07754 9.98741 5.38694 9.84644 5.60128 9.61111L12.7154 1.8334C12.9907 1.53176 13.0734 1.11527 12.9322 0.740966C12.7911 0.366658 12.4476 0.0914162 12.0311 0.0187501C11.6146 -0.0538182 11.1884 0.0873252 10.9131 0.388969H10.9606Z" }));
};
export {
  h as default
};
